import { showDialog } from 'dialogs';
import AddToTransportModal from 'pages/apps/platform/transports/AddToTransportModal';
import type { TransportItem } from 'redux/slices/transportsSlice';

interface AddToTransportOptions {
  readonly objectLabel?: string;
}

/**
 * Build the execute handler for an add-to-transport action: opens the shared
 * `AddToTransportModal` for the given object type and ids via `showDialog`. A
 * definition's `resolve` decides enabled/hidden; this is only the handler.
 */
export const addToTransportExecutor = (
  objectType: TransportItem['object_type'],
  objectIds: readonly number[],
  options: AddToTransportOptions = {}
): (() => void) => {
  return () => {
    showDialog((close) => <AddToTransportModal show onClose={close} objectType={objectType} objectIds={[...objectIds]} objectLabel={options.objectLabel} />);
  };
};
